import BreadCrumbComponent from "../components/Items/BreadCrumb/Index";
import BatchDetailsComponent from "../components/batches/BatchDetailsComponent";
const BatchDetailsPage = () => {
  return (
    <>
      <BreadCrumbComponent
        lastItem="Details"
        routes={[
          { title: "Home", path: "/" },
          { title: "Batches", path: "/batches" },
        ]}
      />

      <BatchDetailsComponent />
    </>
  );
};
export default BatchDetailsPage;
